"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function EnterpriseworkloadsGreyMultitoneFilled(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C6",
    fillRule: "evenodd",
    d: "M6.779 3.05C7.62 1.644 9.066.801 10.63.801c1.916 0 3.915.703 4.417 2.795a2.007 2.007 0 00-.585-.086H8.945A2.006 2.006 0 006.94 5.517V6.52c-1.003 0-3.11.402-3.511 2.007v3.511h-.421c-1.244 0-2.288-1.043-2.288-2.368 0-1.243.923-2.287 2.087-2.407.16 0 .321-.08.361-.24.04-.121 0-.282-.08-.402a2.348 2.348 0 01-.602-1.605c0-1.284 1.043-2.368 2.287-2.368.522 0 1.003.16 1.405.482.08.08.2.12.32.08.121 0 .241-.08.282-.16z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    fillRule: "evenodd",
    d: "M11.33.87l.093.013-2.58 2.63A2.006 2.006 0 006.93 5.465L5.757 6.661c-.977.226-2.063.76-2.34 1.866v.52l-2.146 2.189A2.412 2.412 0 01.709 9.67c0-1.244.923-2.288 2.127-2.408.16 0 .321-.12.361-.24.04-.121 0-.282-.08-.402a2.348 2.348 0 01-.602-1.605c0-1.284 1.043-2.368 2.287-2.368.482 0 .963.16 1.365.482.08.08.2.12.32.08.12 0 .241-.08.281-.16C7.611 1.645 9.056.803 10.621.803c.249 0 .467.031.709.066z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    fillRule: "evenodd",
    d: "M3.511 12.84H3.09C1.404 12.84 0 11.437 0 9.67c0-1.444.923-2.648 2.207-3.049a3.653 3.653 0 01-.401-1.605c0-1.726 1.404-3.17 3.09-3.17.561 0 1.043.12 1.524.401C7.424.843 8.99 0 10.714 0 13.533 0 15.65 1.703 16 4.135a2.005 2.005 0 00-.97-.565C14.457 1.911 12.805.803 10.714.803c-1.565 0-3.01.842-3.852 2.247-.04.08-.16.16-.281.16-.12.04-.2 0-.281-.04-.441-.321-.883-.481-1.404-.481-1.244 0-2.288 1.043-2.288 2.367 0 .602.2 1.164.602 1.605.12.08.12.24.08.401-.08.12-.2.241-.36.241C1.724 7.383.802 8.427.802 9.671c0 1.324 1.043 2.367 2.327 2.367h.381v.803z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C6",
    d: "M11.035 13.543c0 .97-1.55 1.756-3.464 1.756-1.913 0-3.464-.786-3.464-1.756 0-3.01-.615-3.511 1.299-3.511 1.913 0 5.629 2.541 5.629 3.511z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    fillRule: "evenodd",
    d: "M4.91 13.543c0 .023.036.253.574.526.493.25 1.23.427 2.087.427.857 0 1.594-.178 2.087-.428.416-.21.532-.396.564-.48a2.56 2.56 0 00-.362-.433c-.329-.325-.806-.7-1.358-1.058a10.78 10.78 0 00-1.714-.91c-.58-.238-1.057-.353-1.382-.353a4.55 4.55 0 00-.585.033c-.013.147-.004.384.02.81.003.031.004.062.006.094.027.456.062 1.043.062 1.772zm-.803 0c0-.704-.034-1.271-.061-1.726-.088-1.49-.106-1.785 1.36-1.785 1.913 0 5.629 2.541 5.629 3.511 0 .97-1.55 1.756-3.464 1.756-1.913 0-3.464-.786-3.464-1.756z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C6",
    d: "M11.035 11.411c0 .97-1.55 1.756-3.464 1.756-1.913 0-3.558-.627-3.558-1.756 0-2.382-.52-3.511 1.393-3.511s5.63 2.542 5.63 3.511z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    fillRule: "evenodd",
    d: "M10.222 11.456c-.032.084-.148.27-.564.48-.493.25-1.23.428-2.087.428-.884 0-1.65-.147-2.162-.382-.533-.243-.594-.47-.594-.57 0-.489-.02-.933-.039-1.306l-.013-.283c-.02-.452-.017-.727.018-.912a.414.414 0 01.037-.124c-.003.002 0-.002 0 0 .025-.016.162-.084.588-.084.325 0 .803.114 1.382.352.564.231 1.164.554 1.714.91.552.358 1.03.733 1.358 1.059a2.556 2.556 0 01.362.432zm-6.21-.045c0 1.129 1.646 1.756 3.559 1.756 1.913 0 3.464-.786 3.464-1.756S7.32 7.9 5.405 7.9c-1.538 0-1.503.73-1.43 2.254.018.372.038.79.038 1.257z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M11.035 8.778c0 .97-1.572 1.755-3.51 1.755-1.94 0-3.512-.786-3.512-1.755 0-.97 1.572-1.756 3.511-1.756 1.94 0 3.511.786 3.511 1.756z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    fillRule: "evenodd",
    d: "M9.648 9.301c.55-.275.585-.506.585-.523 0-.017-.035-.249-.585-.524-.502-.25-1.252-.43-2.124-.43-.872 0-1.622.18-2.124.43-.55.275-.585.507-.585.524 0 .017.035.248.585.523.502.251 1.252.43 2.124.43.872 0 1.622-.179 2.124-.43zm-2.124 1.232c1.94 0 3.511-.786 3.511-1.755 0-.97-1.572-1.756-3.51-1.756-1.94 0-3.512.786-3.512 1.756s1.572 1.755 3.511 1.755z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M8.025 5.518c0-.554.45-1.004 1.004-1.004h5.517c.554 0 1.003.45 1.003 1.004V15.55H8.025V5.518z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    fillRule: "evenodd",
    d: "M7.624 5.518c0-.776.629-1.405 1.405-1.405h5.517c.776 0 1.405.629 1.405 1.405V15.95H7.623V5.518zm1.405-.602a.602.602 0 00-.602.602v9.63h6.721v-9.63a.602.602 0 00-.602-.602H9.03z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M12.54 12.79a.752.752 0 11-1.505 0 .752.752 0 011.505 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    fillRule: "evenodd",
    d: "M13.4 7.48h-3.225v-.803H13.4v.802zM13.4 9.319h-3.225v-.803H13.4v.803z",
    clipRule: "evenodd"
  }));
}

EnterpriseworkloadsGreyMultitoneFilled.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
EnterpriseworkloadsGreyMultitoneFilled.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = EnterpriseworkloadsGreyMultitoneFilled;
exports["default"] = _default;